import { render } from "./_pdf.vue?vue&type=template&id=4cb2949d"
import script from "./_pdf.vue?vue&type=script&lang=js"
export * from "./_pdf.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__